import { useEffect, useState } from "react";
import { Box, Stack, SvgIcon, Typography } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import CheckCircleOutlineSharpIcon from "@mui/icons-material/CheckCircleOutlineSharp";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";

import { CircularProgress } from "../../components";
import { updateAmazonCrendetials } from "../../services/apiV2";
import { useAppDispatch } from "../../store/hooks";
import { getAmazonCredentialsThunk } from "../../features/user/user.thunk";
import { STATUS_COLORS } from "../../constants";
import { AMAZON_CONNECT_RETURN_PATH_KEY } from "../../components/SellerCentralConnect";

const STATUS_MESSAGE = {
  loading: "Validating amazon credentials...",
  success:
    "Successfully connected to amazon seller central!<br/> Redirecting you back...",
  fail: "Failed to connect amazon account!<br/> Redirecting you to the product analyzer page.",
};  

export const AuthorizeAmazon = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [status, setStatus] = useState<"loading" | "success" | "fail">(
    "loading",
  );

  useEffect(() => {
    const spapiOauthCode = searchParams.get("spapi_oauth_code");
    const state = searchParams.get("state");
    const sellingPartnerId = searchParams.get("selling_partner_id");

    if (spapiOauthCode && state && sellingPartnerId) {
      updateAmazonCrendetials({
        spapi_oauth_code: spapiOauthCode,
        selling_partner_id: sellingPartnerId,
        state: state,
      })
        .then((response) => {
          if (response.data) {
            setStatus("success");
            dispatch(getAmazonCredentialsThunk());
            setTimeout(() => {
              const returnPath = sessionStorage.getItem("quickListReturnPath");
              const connectReturnPath = sessionStorage.getItem(
                AMAZON_CONNECT_RETURN_PATH_KEY,
              );
              sessionStorage.removeItem("quickListReturnPath");
              sessionStorage.removeItem(AMAZON_CONNECT_RETURN_PATH_KEY);
              if (returnPath) {
                const sep = returnPath.includes("?") ? "&" : "?";
                navigate(`${returnPath}${sep}openQuickList=true`);
              } else if (connectReturnPath) {
                // e.g. the Ungated Brands page, where the user started connecting
                navigate(connectReturnPath);
              } else {
                navigate("/");
              }
            }, 2000);
          } else {
            sessionStorage.removeItem(AMAZON_CONNECT_RETURN_PATH_KEY);
            setStatus("fail");
            setTimeout(() => navigate("/"), 2000);
          }
        })
        .catch(() => {
          sessionStorage.removeItem(AMAZON_CONNECT_RETURN_PATH_KEY);
          setStatus("fail");
          setTimeout(() => navigate("/"), 2000);
        });
    }
  }, []);

  return (
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "100%",
        border: "none",
        textAlign: "center",
        p: 6,
      }}
    >
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="center"
        spacing={1}
      >
        {status === "loading" && <CircularProgress size="lg" />}
        {status === "success" && (
          <SvgIcon
            component={CheckCircleOutlineSharpIcon}
            sx={{ color: STATUS_COLORS.success, fontSize: "64px" }}
          />
        )}
        {status === "fail" && (
          <SvgIcon
            component={ErrorOutlineOutlinedIcon}
            sx={{ color: STATUS_COLORS.rejected, fontSize: "64px" }}
          />
        )}
        <Typography
          fontSize="14px"
          textAlign="center"
          dangerouslySetInnerHTML={{ __html: STATUS_MESSAGE[status] }}
        ></Typography>
      </Stack>
    </Box>
  );
};

export default AuthorizeAmazon;
